const btnDom = document.getElementById('download-btn');

btnDom.addEventListener('click', function() {
  let url = 'https://play.google.com/store/apps/details?id=com.stationpc.nas'
  if (isAndroid()) {
    url = 'https://play.google.com/store/apps/details?id=com.stationpc.nas'
  } else if (isiOS()) {
    url = 'https://apps.apple.com/us/app/station-cloud/id6739824716'
  }
  // window.location.href = url
  window.open(url)
});

if (isAndroid()) {
   document.getElementById('download-apk').style.display = 'block'
}
// if (location.href.includes('/download') && isAndroid() || isiOS()) {
//   document.querySelector('.footer-group').style.display = 'none'
// }

function isAndroid() {
  return /android/i.test(navigator.userAgent.toLowerCase());
}

function isiOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
}